/** @file boneMeshes: the wire bones' one unit mesh, a quad stretched along each wire segment. */
import '@babylonjs/core/Meshes/thinInstanceMesh.js';
import { CreatePlane } from '@babylonjs/core/Meshes/Builders/planeBuilder.js';
import type { Mesh } from '@babylonjs/core/Meshes/mesh.js';
import type { Scene } from '@babylonjs/core/scene.js';
import { boneMaterial } from './boneMaterial';
import { VIEWPORT_GROUPS } from './viewportGroups';
import { VIEWPORT_LAYERS } from './viewportLayers';

/**
 * A unit quad drawn once per wire segment (bone edges, joint circles, the root ring): overlay layer, marks group,
 * unpicked, never culled, the always-on-top wire material; hidden until the first update.
 */
export function boneMeshes(scene: Scene): Mesh {
  const mesh = CreatePlane('viewport-bones', { size: 1 }, scene);
  Object.assign(mesh, {
    material: boneMaterial(scene), layerMask: VIEWPORT_LAYERS.overlay, renderingGroupId: VIEWPORT_GROUPS.marks,
    isPickable: false, alwaysSelectAsActiveMesh: true,
  });
  mesh.setEnabled(false);
  return mesh;
}
